import { render, staticRenderFns } from "./AddressIsPublic.vue?vue&type=template&id=1c77a92b&"
import script from "./AddressIsPublic.vue?vue&type=script&lang=ts&"
export * from "./AddressIsPublic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports